// The polyfill chunk loads this first (vite.config.ts), so core-js keeps these browser APIs wherever they exist.
// core-js replaced Chrome's structuredClone over how it clones errors, with a copy that walks every value in
// JavaScript: grouping the whole 1,612-person Tree Studio poster blocked the editor for half a second.
import configure from "core-js/configurator";

configure({ useNative: ["structuredClone"] });
